<template>
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
		 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		 width="82px" viewBox="28 0 82 100" enable-background="new 28 0 82 100"
		 xml:space="preserve">
                        <g>
                            <g>
                                <path fill="#FFFFFF" d="M30,3.562L106.158,50L68.902,72.718L30,96.438V3.562 M28,0v100c27.331-16.667,54.667-33.332,82-50
                                    C82.667,33.334,55.331,16.666,28,0L28,0z"/>
                            </g>
                        </g>
                    </svg>
</template>

<script>
    export default {}
</script>
